import { useEffect, useState } from "react";
import { Card, CardContent, CardMedia, Typography, Grid, Box, Chip } from "@mui/material";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../store/blogSlice/blogSlice";
import { RootState, AppDispatch } from "../../store/store";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LatestBlogs = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { posts: blogs, loading, error } = useSelector((state: RootState) => state.blog);
    const [page, setPage] = useState(1);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [page]);

    useEffect(() => {
        dispatch(fetchPosts(page));
    }, [dispatch, page]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <Box sx={{ p: 4, textAlign: "center", background: "#112240" }}>
            <Link to={`/en/bloglist`} style={{ textDecoration: 'none' }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom color="#64FFDA">
                    {i18n.language === "en" ? "Latest Blog Posts" : "Derniers Articles"}
                </Typography>
            </Link>
            <Slider {...settings}>
                {blogs.slice(0, 4).map((blog, index) => (
                    <Box key={blog._id} sx={{ px: 2 }}>
                        <motion.div whileHover={{ scale: 1.05 }}>
                            <Link to={`/en/bloglist/${blog._id}`} style={{ textDecoration: 'none' }}>
                                <Card sx={{ borderRadius: 4, boxShadow: 3, minHeight: '400px', maxHeight: '400px', margin: 0.5, position: 'relative' }}> {/* Add position: 'relative' here */}
                                    {blog.category && (
                                        <Chip
                                            label={blog.category}
                                            sx={{
                                                position: 'absolute',
                                                top: 10,
                                                right: 10,
                                                zIndex: 1,
                                                backgroundColor: 'white',
                                                borderRadius: '20px',
                                                fontWeight: 'bold',
                                            }}
                                        />
                                    )}
                                    <CardMedia
                                        component="img"
                                        height="180"
                                        image={blog.imageUrl || "/default-blog.jpg"} // Fallback image
                                        alt={blog.title}
                                    />
                                    <CardContent>
                                        <Typography variant="h6" fontWeight="bold" >
                                            {blog.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Link>
                        </motion.div>
                    </Box>
                ))}
            </Slider>
        </Box>
    );
};

export default LatestBlogs;
